import { apiClient, getData, getPage, type Page } from '@/api/client'
import type { components, operations } from '@/api/schema'

type Wire<K extends keyof components['schemas']> = components['schemas'][K]

export type PublicIssuesParams = NonNullable<
  operations['api_v5_public_issues_list']['parameters']['query']
>

export const ipoApi = {
  issues: (query: PublicIssuesParams): Promise<Page<Wire<'PublicIssueCard'>>> =>
    getPage(() => apiClient.GET('/api/v5/public-issues/', { params: { query } })),

  issue: (key: string): Promise<Wire<'PublicIssueDetail'>> =>
    getData(() =>
      apiClient.GET('/api/v5/public-issues/{key}/', {
        params: { path: { key } },
      }),
    ),

  peers: (key: string): Promise<Page<Wire<'PeerListing'>>> =>
    getPage(() =>
      apiClient.GET('/api/v5/public-issues/{key}/peers/', {
        params: { path: { key } },
      }),
    ),
}
